import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './features/auth/AuthContext';
import { LoginPage } from './features/auth/LoginPage';
import { InvitationPage } from './features/auth/InvitationPage';
import { ForgotPasswordPage } from './features/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './features/auth/ResetPasswordPage';
import { MainLayout } from './components/layout/MainLayout';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { ParticipantsListPage } from './features/participants/ParticipantsListPage';
import { NewParticipantPage } from './features/participants/NewParticipantPage';
import { ParticipantDetailPage } from './features/participants/ParticipantDetailPage';
import { NewSamplePage } from './features/samples/NewSamplePage';
import { ShipmentsPage } from './features/shipments/ShipmentsPage';
import { ExportPage } from './features/export/ExportPage';

const AppContent: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <MainLayout user={user} onLogout={() => void logout()}>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/deltakere" element={<ParticipantsListPage />} />
        <Route path="/deltakere/ny" element={<NewParticipantPage />} />
        <Route path="/deltakere/:id" element={<ParticipantDetailPage />} />
        <Route path="/provetaking" element={<NewSamplePage />} />
        <Route path="/forsendelser" element={<ShipmentsPage />} />
        <Route path="/eksport" element={<ExportPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </MainLayout>
  );
};

function AppGate() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center text-sm text-black/50">Laster dnam-ecrf…</div>;
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/invitasjon/:token" element={<InvitationPage />} />
        <Route path="/glemt-passord" element={<ForgotPasswordPage />} />
        <Route path="/tilbakestill-passord/:token" element={<ResetPasswordPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return <AppContent />;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppGate />
      </AuthProvider>
    </Router>
  );
}

export default App;
